import { Outlet } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { ErrorBoundary } from 'react-error-boundary'
import { ErrorFallback } from '@/components/ui/ErrorFallback'

/**
 * RootLayout — outermost wrapper for the entire app.
 * Provides HelmetProvider for dynamic <title> tags.
 * ErrorBoundary catches any unhandled errors at the top level.
 *
 * Renders child routes via <Outlet>.
 */
export const RootLayout = () => {
  return (
    <HelmetProvider>
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <Outlet />
      </ErrorBoundary>
    </HelmetProvider>
  )
}
